import React from 'react';
import { MdHealthAndSafety } from 'react-icons/md';
import { NavSubmenuDivider } from './navMenuLayout';

const QHSE_CHILD_ROUTES = [
  '/qhse?tab=personnel',
  '/qhse?tab=daily-logs',
  '/qhse?tab=env-health',
  '/qhse?tab=comments',
  '/qhse?tab=daily-report',
  '/qhse?tab=kpis',
  '/qhse?tab=settings',
  '/qhse/document-control',
  '/hr/hse-induction',
];

export default function QhseNavSection({ MenuItem, SubMenuItem, hasMenuAccess, hasMenuAccessOrChild }) {
  if (!hasMenuAccessOrChild('/qhse', QHSE_CHILD_ROUTES)) {
    return null;
  }
  return (
    <MenuItem customIcon={<MdHealthAndSafety style={{ width: '24px', height: '24px' }} />} title="QHSE" id="qhse">
      {hasMenuAccess('/qhse?tab=personnel') && <SubMenuItem to="/qhse?tab=personnel">Personnel</SubMenuItem>}
      {hasMenuAccess('/qhse?tab=daily-logs') && <SubMenuItem to="/qhse?tab=daily-logs">Daily Logs</SubMenuItem>}
      {hasMenuAccess('/qhse?tab=env-health') && (
        <SubMenuItem to="/qhse?tab=env-health">Environment & Health</SubMenuItem>
      )}
      {hasMenuAccess('/qhse?tab=comments') && (
        <SubMenuItem to="/qhse?tab=comments">Comments & Meetings</SubMenuItem>
      )}
      {hasMenuAccess('/qhse?tab=daily-report') && (
        <SubMenuItem to="/qhse?tab=daily-report" className="fw-bold text-warning">Daily Report</SubMenuItem>
      )}
      {hasMenuAccess('/qhse?tab=kpis') && <SubMenuItem to="/qhse?tab=kpis">KPI Dashboard</SubMenuItem>}
      {hasMenuAccess('/qhse/document-control') && (
        <SubMenuItem to="/qhse/document-control">Document Control</SubMenuItem>
      )}
      {hasMenuAccess('/hr/hse-induction') && <SubMenuItem to="/hr/hse-induction">HSE Induction</SubMenuItem>}
      <NavSubmenuDivider />
      {hasMenuAccess('/qhse?tab=settings') && <SubMenuItem to="/qhse?tab=settings">⚙ Settings</SubMenuItem>}
    </MenuItem>
  );
}
